import { render } from "./TextAlertModal.vue?vue&type=template&id=17714ebb"
import script from "./TextAlertModal.vue?vue&type=script&lang=js"
export * from "./TextAlertModal.vue?vue&type=script&lang=js"

import "./TextAlertModal.vue?vue&type=style&index=0&id=17714ebb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__